<template>
  <div class="directory-page">
    <section class="page-hero">
      <div class="page-hero__shade"></div>
      <div class="site-shell page-hero__content">
        <p class="eyebrow">ARTISAN DIRECTORY</p>
        <h1>匠人名录</h1>
        <p>一刀一刻皆有来处，在这里认识手艺背后的人。</p>
      </div>
    </section>

    <section class="page-section">
      <div class="site-shell">
        <header class="list-heading">
          <div>
            <p>玉雕匠人的专业档案</p>
          </div>
          <h2>以匠心，见真章</h2>
        </header>

        <div v-loading="loading" class="artisan-grid">
          <article v-for="master in masterList" :key="master.id" class="artisan-card" tabindex="0" @click="viewDetail(master.id)" @keyup.enter="viewDetail(master.id)">
            <div class="artisan-card__portrait">
              <img v-if="master.avatar" :src="getFullImageUrl(master.avatar)" :alt="master.masterName" @error="handleImageError">
              <div v-else class="image-placeholder"><i class="el-icon-user"></i></div>
              <span>查看档案</span>
            </div>
            <div class="artisan-card__body">
              <p>{{ master.craft || '玉雕技艺' }}</p>
              <h3>{{ master.masterName }}</h3>
              <i class="el-icon-arrow-right"></i>
            </div>
          </article>
        </div>

        <el-empty v-if="!loading && masterList.length === 0" :description="loadError ? '匠人数据加载失败' : '暂无匠人数据'">
          <el-button v-if="loadError" type="primary" plain @click="fetchMasters">重新加载</el-button>
        </el-empty>

        <div class="pagination-wrapper" v-if="pagination.total > pagination.pageSize">
          <el-pagination @current-change="handlePageChange" :current-page="pagination.currentPage" :page-size="pagination.pageSize" layout="prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getMastersList } from '@/api/masters'

export default {
  name: 'MastersPage',
  data() {
    return {
      allMasters: [],
      loading: false,
      loadError: false,
      pagination: { currentPage: 1, pageSize: 9, total: 0 }
    }
  },
  computed: {
    masterList() {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      return this.allMasters.slice(start, start + this.pagination.pageSize)
    }
  },
  created() {
    this.fetchMasters()
  },
  methods: {
    async fetchMasters() {
      this.loading = true
      this.loadError = false
      try {
        let response
        try {
          response = await getMastersList({ pageNum: 1, pageSize: 1000 })
        } catch (firstError) {
          console.warn('首次获取匠人列表失败，正在重试:', firstError)
          response = await getMastersList({ pageNum: 1, pageSize: 1000 })
        }
        if (response.code === 200) {
          this.allMasters = this.shuffleMasters(response.rows || [])
          this.pagination.total = this.allMasters.length
        } else {
          this.loadError = true
          this.$message.error(response.msg || '获取匠人列表失败')
        }
      } catch (error) {
        console.error('获取匠人列表出错:', error)
        this.loadError = true
        this.$message.error('获取匠人列表失败')
      } finally {
        this.loading = false
      }
    },
    shuffleMasters(items) {
      const shuffled = items.slice()
      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const target = Math.floor(Math.random() * (index + 1))
        ;[shuffled[index], shuffled[target]] = [shuffled[target], shuffled[index]]
      }
      return shuffled
    },
    getFullImageUrl(path) {
      if (!path) return ''
      return path.startsWith('http') ? path : process.env.VUE_APP_BASE_API + path
    },
    handleImageError(event) {
      if (event && event.target) event.target.style.display = 'none'
    },
    viewDetail(id) {
      this.$router.push('/masters/' + id)
    },
    handlePageChange(page) {
      this.pagination.currentPage = page
      window.scrollTo({ top: 220, behavior: 'smooth' })
    }
  }
}
</script>
